import React from 'react';
import {
    FaEnvelope,
    FaFacebookF,
    FaXTwitter,
    FaRedditAlien,
    FaLinkedinIn,
    FaTelegram
} from "react-icons/fa6";
import { FaCalendarAlt } from "react-icons/fa";
import Footer from '../component/Footer';
import Navbar from '../component/Navbar';
import HeadingWithWatermark from '../component/HeadingWithWatermark';

// Sample upcoming events data with optional registration link
const upcomingEvents = [
    {
        id: 1,
        title: '29th ICSME – Global SME Summit 2025',
        date: 'October 15–17, 2025',
        location: 'New Delhi, India',
        image: '/img/26Feb_event.jpeg',
        description: 'Join global leaders to explore innovative pathways for sustainable SME growth.',
        registrationLink: 'https://example.com/register/icsme-2025', // has registration
    },
    {
        id: 2,
        title: 'WASME  Workshop on Digital Transformation',
        date: 'November 5–6, 2025',
        location: 'Dubai, UAE',
        image: '/img/30_jan_event.jpeg',
        description: 'Hands-on sessions on AI, blockchain, and e-commerce for MSMEs.',
   registrationLink: 'https://example.com/register/icsme-2025', // has registration
    },
    {
        id: 3,
        title: 'MSME Trade Fair & Buyer-Seller Meet',
        date: 'December 2–4, 2025',
        location: 'Mumbai, India',
        image: '/img/24_April.jpeg',
        description: 'Showcase your products and connect with global buyers.',
        registrationLink: 'https://example.com/register/tradefair',
    },

];

// Reusable Event Card Component
const EventCard = ({ event }) => {
    const skyBlue = "rgb(43, 147, 208)";
    return (
        <div className="flex flex-col space-y-3">

            {/* Image */}
            <img
                src={event.image}
                alt={event.title}
                className="w-full h-[220px] object-cover"
            />

            {/* Icons + Date Row */}
            <div className="flex items-center space-x-4 text-sm">

                <div className="flex items-center space-x-3" style={{ color: skyBlue }}>
                    <FaEnvelope className="cursor-pointer" />
                    <FaFacebookF className="cursor-pointer" />
                    <FaXTwitter className="cursor-pointer" />
                    {/* <FaRedditAlien className="cursor-pointer" /> */}
                    <FaLinkedinIn className="cursor-pointer" />
                    {/* <FaTelegram className="cursor-pointer" /> */}
                </div>

                {/* Date */}
                <div className="flex items-center text-gray-700 ml-3">
                    <FaCalendarAlt className="mr-2" style={{ color: skyBlue }} />
                    <span className="font-medium">{event.date}</span>
                </div>
            </div>

            {/* Title + Register Button */}
            <div className="flex items-start justify-between gap-4">

                <h3 className="text-2xl line-clamp-3 font-bold leading-snug text-black max-w-[80%]">
                    {event.title}
                </h3>

                {event.registrationLink && (
                    <a
                        href={event.registrationLink}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-white px-4 py-2 text-sm font-medium rounded-md whitespace-nowrap"
                        style={{ backgroundColor: skyBlue }}
                    >
                        Register
                    </a>
                )}
            </div>
        </div>
    );
};

// Page Component with Grid of Events
const UpcomingEventsPage = () => {
    return (
        <>
        <Navbar/>
              <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100">


            {/* Main Content */}
            <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
                <div className="text-center mb-12">
                  <HeadingWithWatermark
          title="Upcoming Events"
          watermarkText="WASME"
          color="#1b73a7"
          align="center"
        />
                    <p className="text-lg text-gray-600 max-w-2xl mx-auto">
                        Join us at our global conferences, workshops, and networking opportunities designed for MSME growth.
                    </p>
                </div>

                {/* Events Grid */}
               <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-10">
  {upcomingEvents.map((event) => (
    <EventCard key={event.id} event={event} />
  ))}
</div>

            </main>


        </div>
        <Footer/>       
        </>
      
    );
};

export default UpcomingEventsPage;